module.exports = __webpack_public_path__ + "7ba233fb974e96aabf970253681e5591.png";